module.exports = __webpack_public_path__ + "static/img/banner-one-thumb.d7d4c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner-one-thumb.png
// module id = gY9/
// module chunks = 0